// extracted by mini-css-extract-plugin
module.exports = {"card-link":"CredentialCard_card-link_1gpnX","card-heading":"CredentialCard_card-heading_2rJlM","card-actions":"CredentialCard_card-actions_2YcyI"};